import scroll from "./scroll";

const modal = {
    open: false,

    init() {
        $(document).on("click", "._open_mentions", function () {
            //$("html").addClass("disable-locomotive-scroll");
            $(".__mentions").addClass("_show");
            //scroll.locomotiveScroll.update();
            scroll.locomotiveScroll.stop();
            // Permettre le scroll dans le modal
            //$(".__mentions").css("overflow", "auto");
        });

        $(document).on("click", ".__close_modal", function () {
            $(".__mentions").removeClass("_show");
           // $("html").removeClass("disable-locomotive-scroll");
            scroll.locomotiveScroll.start();
        });

        $(document).on("click", ".__list_select", function () {
            $(this).toggleClass("_open");
        });

        $(document).on("click", "._options > span", function () {
            let _id = $(this).data("id");
            let _txt = $(this).html();
            $(".__choice_value > span").html(_txt);
            $("input[name=recall_type]").val(_id);
        });

    }
};

export default modal;
